import { Icons } from '@cast/design-system';
import { useNavigate } from '@cast/infrastructure-organization';
import { useInstanceDetails } from 'features/db-optimization/v2/hooks/useInstanceDetails';
import { useDboParams } from 'features/db-optimization/v2/hooks/useDboParams';
import { buildDboRoute, DboRoute } from 'features/db-optimization/v2/routes';
import { DatabaseViewModelV2 } from 'features/db-optimization/v2/types';

import { HeaderSelect } from './_components/HeaderSelect';
import { HeaderSelectConfig } from './types';

export const DboDatabaseSelect = () => {
  const navigate = useNavigate();
  const { dbServerId, databaseId } = useDboParams();
  const { data, isLoading, error, refetch } = useInstanceDetails();
  const hasError = !!error;

  const databases: DatabaseViewModelV2[] = data?.databases ?? [];

  const options = databases.map((database) => ({
    item: database,
    selected: database.id === databaseId,
  }));

  const config: HeaderSelectConfig<DatabaseViewModelV2> = {
    options,
    isLoading,
    hasError,
    refetch,
    getItemId: ({ id }) => id,
    getItemName: ({ name }) => name,
    renderItemIcon: () => <Icons.Database size={14} />,
    renderTriggerIcon: () => <Icons.Database size={20} />,
    getSearchableText: ({ name }) => [name],
    onSelect: ({ id }) =>
      navigate(
        buildDboRoute(DboRoute.DB_DASHBOARD, {
          dbServerId: dbServerId!,
          databaseId: id,
        })
      ),
    testIdPrefix: 'dbo-database-chooser',
    searchPlaceholder: 'Enter database name',
    emptyTitle: 'No databases',
    emptySubtitle: 'Connect a database to get started',
    notFoundTitle: 'No databases found',
    notFoundSubtitle: 'Adjust your search criteria',
    errorTitle: 'Failed to load databases',
    defaultTriggerLabel: 'Database',
    emptyIcon: <Icons.Database size={14} />,
  };

  return <HeaderSelect config={config} />;
};
